import React from 'react';
import { Dialog, Tooltip, Flex, IconButton } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { CheckIcon, EditIcon, RemoveRedEyeIcon } from 'shared/icons';
import { CompanySlide } from 'admin/types';

import { ManagerCard } from '../manager-card';
import { DeactivatedDialog } from '../deactivated-dialog';
import { SlideOrderEditDialog } from '../slide-order-edit-dialog';

import './slider-actions-menu.scss';

type SliderMenuAction = 'VIEW' | 'EDIT' | 'DEACTIVATE' | 'EMPTY';

const SliderActionsMenuView = ({ slide }: { slide: CompanySlide }) => {
   const [open, setOpen] = React.useState<boolean>(false);
   const [action, setAction] = React.useState<SliderMenuAction>('EMPTY');

   return (
      <Flex className="slider-action-menu" direction="column" gap="1" align="center">
         <Tooltip content="View" side="left">
            <IconButton
               color="blue"
               className="action-trigger"
               highContrast
               onClick={() => {
                  setOpen(true);
                  setAction('VIEW');
               }}
            >
               <RemoveRedEyeIcon width={20} height={20} />
            </IconButton>
         </Tooltip>

         <Tooltip content="Edit order" side="left">
            <IconButton
               color="blue"
               className="action-trigger"
               highContrast
               onClick={() => {
                  setOpen(true);
                  setAction('EDIT');
               }}
            >
               <EditIcon width={20} height={20} />
            </IconButton>
         </Tooltip>

         <Tooltip content="Deactivate" side="left">
            <IconButton
               color="red"
               className="action-trigger"
               onClick={() => {
                  setOpen(true);
                  setAction('DEACTIVATE');
               }}
            >
               <CheckIcon width={20} height={20} />
            </IconButton>
         </Tooltip>

         <Dialog.Root open={open} onOpenChange={(o) => setOpen(o)}>
            <Dialog.Content onOpenAutoFocus={(e) => e.preventDefault()}>
               {
                  {
                     VIEW: <ManagerCard slide={slide} />,
                     DEACTIVATE: (
                        <DeactivatedDialog
                           slide={slide}
                           onClose={() => {
                              setOpen(false);
                           }}
                        />
                     ),
                     EDIT: (
                        <SlideOrderEditDialog
                           slide={slide}
                           onClose={() => {
                              setOpen(false);
                           }}
                        />
                     ),
                     EMPTY: <></>,
                  }[action]
               }
            </Dialog.Content>
         </Dialog.Root>
      </Flex>
   );
};

export const SliderActionsMenu = observer(SliderActionsMenuView);
